"use-strict";

var CLASS_COLLAPSED = 'is-scroll-collapsed';
var CLASS_COLLAPSING = 'is-collapsing';
var CLASS_HAS_VIDEO = 'has-video';
var CLASS_ACTIVE = 'is-active';
var DRAG_THRESHOLD = 3;
var BLOCK_MS = 600;
var RESTORE_MS = 1000;

class FloatingVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this._init();
  }

  _init() {
    this._expanded = false;
    this._scrolled = false;
    this._dragging = false;
    this._dragMoved = false;
    this._dragStartX = 0;
    this._dragStartY = 0;
    this._dragLeft = 0;
    this._dragTop = 0;
    this._scrollTimer = 0;
    this._blockTil = 0;
    this._snapping = false;

    this._expandBtn = this.querySelector('.js-floating-video-expand');
    this._closeBtn = this.querySelector('.js-floating-video-close');
    this._overlay = this.querySelector('.js-floating-video-overlay');
    this._backdrop = this.querySelector('.js-floating-video-backdrop');
    this._vid = this.querySelector('.js-floating-video-collapsed');
    this._vidBig = this.querySelector('.js-floating-video-expanded');
    this._wrap = this._overlay ? this._overlay.querySelector('.floating-video__overlay-video-wrapper') : null;

    if (this._expandBtn) this._expandBtn.addEventListener('click', this._expand.bind(this));
    if (this._closeBtn) this._closeBtn.addEventListener('click', this._collapse.bind(this));
    if (this._backdrop) this._backdrop.addEventListener('click', this._collapse.bind(this));

    document.addEventListener('keydown', this._onKey.bind(this));

    if (this._vid) {
      this._vid.addEventListener('click', this._onClick.bind(this));
      this._vid.addEventListener('pause', this._onPause.bind(this));
    }

    this.addEventListener('mousedown', this._onDragStart.bind(this));
    this.addEventListener('touchstart', this._onDragStart.bind(this));
    document.addEventListener('mousemove', this._onDragMove.bind(this));
    document.addEventListener('touchmove', this._onDragMove.bind(this), { passive: false });
    document.addEventListener('mouseup', this._onDragEnd.bind(this));
    document.addEventListener('touchend', this._onDragEnd.bind(this));

    if (this._wrap) {
      this._wrap.addEventListener('transitionend', this._onTransEnd.bind(this));
    }

    window.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
  }

  _onClick(e) {
    if (this._dragMoved) { e.preventDefault(); e.stopPropagation(); return; }
    this._expand();
  }

  _onPause() {
    var self = this;
    if (!self._expanded && self._vid && !self._dragging) {
      setTimeout(function () {
        if (self._vid && !self._expanded && !self._dragging) self._vid.play().catch(function () {});
      }, 150);
    }
  }

  _onScroll() {
    var self = this;
    if (self._expanded || self._dragging || self._snapping) return;
    if (Date.now() < self._blockTil) return;

    if (!self._scrolled) {
      self._scrolled = true;
      self.classList.add(CLASS_COLLAPSED);
    }

    if (self._scrollTimer) clearTimeout(self._scrollTimer);
    self._scrollTimer = setTimeout(function () {
      self._scrolled = false;
      self.classList.remove(CLASS_COLLAPSED);
    }, RESTORE_MS);
  }

  _onDragStart(e) {
    if (this._expanded) return;

    this._dragging = true;
    this._dragMoved = false;

    var p = e.touches ? e.touches[0] : e;
    this._dragStartX = p.clientX;
    this._dragStartY = p.clientY;

    var r = this.getBoundingClientRect();
    this._dragLeft = r.left;
    this._dragTop = r.top;

    this.style.bottom = 'auto';
    this.style.right = 'auto';
    this.style.left = r.left + 'px';
    this.style.top = r.top + 'px';
    this.style.transition = 'none';
    this.style.cursor = 'grabbing';
  }

  _onDragMove(e) {
    if (!this._dragging) return;

    var p = e.touches ? e.touches[0] : e;
    var dx = p.clientX - this._dragStartX;
    var dy = p.clientY - this._dragStartY;

    if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) this._dragMoved = true;

    var l = Math.max(0, Math.min(this._dragLeft + dx, window.innerWidth - this.offsetWidth));
    var t = Math.max(0, Math.min(this._dragTop + dy, window.innerHeight - this.offsetHeight));

    this.style.left = l + 'px';
    this.style.top = t + 'px';
  }

  _onDragEnd() {
    if (!this._dragging) return;
    this._dragging = false;
    this.style.cursor = '';

    var r = this.getBoundingClientRect();
    var snapL = (r.left + r.width / 2) < (window.innerWidth / 2);
    var bottomPx = window.innerHeight - r.bottom;

    this._snapping = true;
    this.style.transition = 'left 0.25s ease, bottom 0.25s ease, right 0.25s ease';
    this.style.top = 'auto';
    this.style.bottom = bottomPx + 'px';

    if (snapL) { this.style.left = '12px'; this.style.right = 'auto'; }
    else { this.style.left = 'auto'; this.style.right = '12px'; }

    this._blockTil = Date.now() + 400;

    var self = this;
    setTimeout(function () {
      self.style.transition = '';
      self._snapping = false;
    }, 300);
  }

  _dim() {
    var pad = window.innerWidth < 768 ? 16 : 40;
    var mw = window.innerWidth - pad * 2;
    var mh = window.innerHeight - pad * 2;
    var ratio = 9 / 16;
    if (this._vid && this._vid.videoWidth && this._vid.videoHeight) ratio = this._vid.videoWidth / this._vid.videoHeight;
    return (mh * ratio > mw) ? { w: mw, h: mw / ratio } : { w: mh * ratio, h: mh };
  }

  _setWrap(t, l, w, h) {
    if (!this._wrap) return;
    this._wrap.style.top = t + 'px';
    this._wrap.style.left = l + 'px';
    this._wrap.style.width = w + 'px';
    this._wrap.style.height = h + 'px';
  }

  _expand() {
    if (this._expanded) return;
    this._expanded = true;
    this._blockTil = Date.now() + BLOCK_MS;

    if (this._vid) this._vid.pause();

    var r = this.getBoundingClientRect();
    var end = this._dim();
    this._setWrap(r.top, r.left, r.width, r.height);
    if (this._wrap) this._wrap.classList.remove(CLASS_COLLAPSING);
    if (this._overlay) { this._overlay.classList.add(CLASS_ACTIVE); document.body.style.overflow = 'hidden'; }

    var self = this;
    requestAnimationFrame(function () {
      self._setWrap((window.innerHeight - end.h) / 2, (window.innerWidth - end.w) / 2, end.w, end.h);
    });
  }

  _collapse() {
    if (!this._expanded) return;
    this._expanded = false;

    if (this._vidBig) { this._vidBig.pause(); if (this._wrap) this._wrap.classList.remove(CLASS_HAS_VIDEO); }
    if (this._wrap) this._wrap.classList.add(CLASS_COLLAPSING);

    var r = this.getBoundingClientRect();
    this._setWrap(r.top, r.left, r.width, r.height);
  }

  _onTransEnd(e) {
    if (e.propertyName !== 'width' && e.propertyName !== 'height') return;
    if (!this._wrap) return;

    var collapsing = this._wrap.classList.contains(CLASS_COLLAPSING);

    if (this._expanded && !collapsing) {
      if (this._vidBig && this._vid) {
        this._vidBig.src = this._vid.src;
        this._vidBig.load();
        this._vidBig.play().catch(function () {});
        this._wrap.classList.add(CLASS_HAS_VIDEO);
      }
      return;
    }

    if (!this._expanded && collapsing) {
      if (this._overlay) { this._overlay.classList.remove(CLASS_ACTIVE); document.body.style.overflow = ''; }
      if (this._vidBig) this._vidBig.removeAttribute('src');
      if (this._vid) this._vid.play().catch(function () {});
      this._wrap.classList.remove(CLASS_COLLAPSING);
      this._blockTil = Date.now() + BLOCK_MS;
      this.style.top = '';
      this.style.left = '';
      this.style.bottom = '';
      this.style.right = '';
      this.style.transition = '';
    }
  }

  _onKey(e) {
    if (e.key === 'Escape' && this._expanded) this._collapse();
  }
}

if (!customElements.get('floating-video-player')) {
  customElements.define('floating-video-player', FloatingVideoPlayer);
}
